<template>
	<i class="icon icon-solicitacao"/>
</template>

<script>
export default {}
</script>
